import { useCallback, useMemo } from 'react';
import { useTabFiltersFunctions } from './filters/useTabFilterFunctions';
import { SortOrder } from '../../common/types';
import { getSortOptions, getSelectedSortOption, defaultSortOptionsMap } from './sortUtilsAndConsts';
import { sortByProperty } from './sortByProperty';
import { DocumentationTabTypes } from '../../../types/enums/DocumentationTabTypes';
import { useSelector } from 'react-redux';
import { selectTopBarSort } from '../../../reducers/documentation/documentationTopBarReducer';

export const useSortElements = ({
  activeTab,
  isManagePackageInstalled,
  items,
}: {
  activeTab: DocumentationTabTypes;
  isManagePackageInstalled: boolean;
  items: any;
}) => {
  const sortState = useSelector(selectTopBarSort);
  const _sortKey = sortState?.sortBy ?? defaultSortOptionsMap[activeTab];

  const { registerSortChange } = useTabFiltersFunctions();

  const onSortChange = useCallback(
    (sortKey: string, sortOrder: string) => {
      registerSortChange({
        sortKey,
        sortOrder,
      });
    },
    [registerSortChange],
  );

  const _sortOptions = getSortOptions(activeTab, isManagePackageInstalled);
  const selectedSortOption = getSelectedSortOption(_sortOptions, _sortKey);

  let sortedItems = items ?? [];
  const itemsNotElementsMap = items;

  const sortOrder = useMemo(
    () => sortState?.sortOrder ?? selectedSortOption?.sortOrder ?? SortOrder.ASC,
    [sortState, selectedSortOption],
  );

  switch (activeTab) {
    case DocumentationTabTypes.CARDS_LIST:
      sortedItems = sortByProperty(items, _sortKey, sortOrder);
      break;

    default:
      sortedItems = sortByProperty(itemsNotElementsMap, _sortKey, sortOrder);
      break;
  }

  return {
    onSortChange,
    sortedItems,
    _sortOptions,
    _sortKey,
    sortOrder,
  };
};
